import Vue from 'vue'
import Vuex from 'vuex'
import moduleAuth from './modules/auth'
import moduleSettings from './modules/settings'
import moduleRoutes from './modules/routes'
import moduleStops from './modules/stops'
import moduleCars from './modules/cars'
import moduleRect from './modules/rect'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    moduleAuth,
    moduleSettings,
    moduleRoutes,
    moduleStops,
    moduleCars,
    moduleRect
  },
  
  plugins: [createPersistedState({
    paths: ['moduleRect', 'moduleSettings'],
  })]
})